/**
 * KyznCards Theme JavaScript
 */

(function() {
  'use strict';

  // Mobile Menu
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuOverlay = document.querySelector('[data-mobile-menu-overlay]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');

  function openMobileMenu() {
    mobileMenu?.classList.add('active');
    mobileMenuOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu?.classList.remove('active');
    mobileMenuOverlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  mobileMenuToggle?.addEventListener('click', openMobileMenu);
  mobileMenuClose?.addEventListener('click', closeMobileMenu);
  mobileMenuOverlay?.addEventListener('click', closeMobileMenu);

  // Search Modal
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchModal = document.querySelector('[data-search-modal]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = searchModal?.querySelector('.search-modal__input');

  function openSearch() {
    searchModal?.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 100);
  }

  function closeSearch() {
    searchModal?.classList.remove('active');
    document.body.style.overflow = '';
  }

  searchToggle?.addEventListener('click', openSearch);
  searchClose?.addEventListener('click', closeSearch);
  
  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchModal?.classList.contains('active')) {
      closeSearch();
    }
  });
  
  // Close when clicking outside
  searchModal?.addEventListener('click', (e) => {
    if (e.target === searchModal) {
      closeSearch();
    }
  });

  // FAQ Accordion
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const isActive = question.classList.contains('active');

      // Close all others
      faqQuestions.forEach(q => {
        q.classList.remove('active');
        q.nextElementSibling?.classList.remove('active');
      });

      // Toggle current
      if (!isActive) {
        question.classList.add('active');
        answer?.classList.add('active');
      }
    });
  });

  // Collection Filters
  const filterOptions = document.querySelectorAll('[data-filter-option]');

  filterOptions.forEach(option => {
    option.addEventListener('click', function() {
      const filterGroup = this.closest('[data-filter-group]');
      
      filterGroup?.querySelectorAll('[data-filter-option]').forEach(opt => {
        opt.classList.remove('active');
      });
      
      this.classList.add('active');
      
      // You would typically trigger a page reload or AJAX request here
      // For now, this just updates the UI
    });
  });

  // Fade In Animation on Scroll
  const fadeElements = document.querySelectorAll('.fade-in');

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  fadeElements.forEach(el => observer.observe(el));

  // Trigger initial animations for elements in viewport
  window.addEventListener('load', () => {
    fadeElements.forEach(el => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        el.classList.add('visible');
      }
    });
  });

  // Product Quantity Selector
  const quantitySelectors = document.querySelectorAll('[data-quantity-selector]');

  quantitySelectors.forEach(selector => {
    const minusBtn = selector.querySelector('[data-quantity-minus]');
    const plusBtn = selector.querySelector('[data-quantity-plus]');
    const input = selector.querySelector('[data-quantity-input]');

    minusBtn?.addEventListener('click', () => {
      const currentValue = parseInt(input.value) || 1;
      if (currentValue > 1) {
        input.value = currentValue - 1;
        input.dispatchEvent(new Event('change'));
      }
    });

    plusBtn?.addEventListener('click', () => {
      const currentValue = parseInt(input.value) || 1;
      const max = parseInt(input.max) || 999;
      if (currentValue < max) {
        input.value = currentValue + 1;
        input.dispatchEvent(new Event('change'));
      }
    });
  });

  // Add to Cart (AJAX)
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn?.textContent;

      if (submitBtn) {
        submitBtn.textContent = 'Adding...';
        submitBtn.disabled = true;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        const data = await response.json();

        if (response.ok) {
          // Update cart count
          updateCartCount();
          
          if (submitBtn) {
            submitBtn.textContent = 'Added!';
            setTimeout(() => {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }, 2000);
          }
        } else {
          throw new Error(data.message || 'Error adding to cart');
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        if (submitBtn) {
          submitBtn.textContent = 'Error';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        }
      }
    });
  });

  // Update Cart Count
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCounts = document.querySelectorAll('[data-cart-count]');
      cartCounts.forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // Product Image Gallery
  const galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
  const galleryMain = document.querySelector('[data-gallery-main]');

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const imageSrc = thumb.dataset.imageSrc;
      
      galleryThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      
      if (galleryMain && imageSrc) {
        galleryMain.src = imageSrc;
      }
    });
  });

  // Newsletter Form
  const newsletterForms = document.querySelectorAll('[data-newsletter-form]');

  newsletterForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const emailInput = form.querySelector('input[type="email"]');
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn?.textContent;

      if (submitBtn) {
        submitBtn.textContent = 'Subscribing...';
        submitBtn.disabled = true;
      }

      // Simulate subscription (replace with actual Klaviyo/Mailchimp integration)
      setTimeout(() => {
        if (submitBtn) {
          submitBtn.textContent = 'Subscribed!';
          emailInput.value = '';
          
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 3000);
        }
      }, 1000);
    });
  });

})();
